var _SidebarMenu, _SidebarMenu2;
import React from 'react';
import { Drawer } from '@crehana/compass.ui';
import { useSidebar } from "./sidebar-context";
import { SidebarMenu } from "./sidebar-menu";
import { jsx as _jsx } from "react/jsx-runtime";
export var CrossPlatformNavigationComponent = function CrossPlatformNavigationComponent() {
  var context = useSidebar();
  return /*#__PURE__*/_jsx("div", {
    children: context.isSm ? _SidebarMenu || (_SidebarMenu = /*#__PURE__*/_jsx(SidebarMenu, {})) : /*#__PURE__*/_jsx(Drawer, {
      open: context.mobileSidebarOpen,
      onDismiss: context.hideMobileSidebar,
      position: "left",
      children: _SidebarMenu2 || (_SidebarMenu2 = /*#__PURE__*/_jsx(SidebarMenu, {
        fullWidth: true
      }))
    })
  });
};